import { useCallback, useState } from "react";
import { Button } from "react-bootstrap";
import Cropper from "react-easy-crop";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import getCroppedImg from "../../functions/cropImage";
import { CreatePublicURL } from "../../functions/urlHelper";
import { SaveBiography } from "../../Services/UserProfileService";
import '../../profileupdate.css';

export default function ProfileUpdatePage() {
    const auth = useSelector(state => state.authSlice);
    const navigate = useNavigate();

    const [myInformation, setMyInformation] = useState({
        biography: auth?.data?.biography || "",
        instagramURL: auth?.data?.instagramURL || "",
        youtubeURL: auth?.data?.youtubeURL || "",
        twitterURL: auth?.data?.twitterURL || "",
        facebookURL: auth?.data?.facebookURL || "",
        linkedinURL: auth?.data?.linkedinURL || "",
        webSiteURL: auth?.data?.webSiteURL || "",
        emailPermission: auth?.data?.emailPermission || false,
    });
    
    const [profilePictureBlob, setProfilePictureBlob] = useState(false);
    const [businessCardBlob, setBusinessCardBlob] = useState(false);
    const [rotation, setRotation] = useState(0);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [croppedImage, setCroppedImage] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                profilePictureBlob,
                croppedAreaPixels,
                rotation
            );
            setCroppedImage(croppedImage);
        } catch (e) {
            console.error(e);
        }
    }, [profilePictureBlob, croppedAreaPixels, rotation]);

    const handleInfo = (target) => {
        const id = target.id;
        var value = target.value;
        if (value.includes("http://") || value.includes("https://")) {
            value = value.replaceAll("http://", "").replaceAll("https://", "");
            target.value = value;
        }
        const newData = { ...myInformation };
        if (id === 'profilePicture') {
            setProfilePictureBlob(URL.createObjectURL(target.files[0]));
            newData[id] = target.files[0];
        }
        else if (id === 'businessCard') {
            setBusinessCardBlob(URL.createObjectURL(target.files[0]));
            newData[id] = target.files[0];
        }
        else if (id === 'emailPermission') {
            newData[id] = target.checked;
        }
        else {
            newData[id] = value;
        }
        setMyInformation(newData);
    };

    const handleSaveBiography = async () => {
        if (croppedAreaPixels != null) {
            const croppedImage = await getCroppedImg(
                profilePictureBlob,
                croppedAreaPixels,
                rotation
            );
            myInformation["profilePicture"] = croppedImage;
        }
        SaveBiography(myInformation, function (resp) {
            window.location.href = "/Profile/" + auth?.data?.id;
        });
    };

    const handleCancel = () => {
        navigate("/Profile/" + auth?.data?.id);
    };

    return (
        <div className="social-container container-fluid row justify-content-center" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <div className="col-md-8 col-lg-7">
                <div className="card card-default shadow-sm border-0">
                    <div className="card-header bg-white border-bottom py-3">
                        <h4 className="m-0 font-weight-bold text-primary">Update Profile</h4>
                    </div>
                    <div className="card-body p-4">
                        <div className='form-vertical'>
                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Biography:
                                </label>
                                <div className='col-md-9'>
                                    <textarea id="biography" className='form-control' placeholder="Please enter your biography" rows="3" onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.biography}></textarea>
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Instagram:
                                </label>
                                <div className='col-md-9'>
                                    <input type="text" className='form-control' id='instagramURL' onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.instagramURL} />
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Twitter:
                                </label>
                                <div className='col-md-9'>
                                    <input type="text" className='form-control' id='twitterURL' onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.twitterURL} />
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Linkedin:
                                </label>
                                <div className='col-md-9'>
                                    <input type="text" className='form-control' id='linkedinURL' onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.linkedinURL} />
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Facebook:
                                </label>
                                <div className='col-md-9'>
                                    <input type="text" className='form-control' id='facebookURL' onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.facebookURL} />
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Youtube:
                                </label>
                                <div className='col-md-9'>
                                    <input type="text" className='form-control' id='youtubeURL' onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.youtubeURL} />
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Web Site:
                                </label>
                                <div className='col-md-9'>
                                    <input type="text" className='form-control' id='webSiteURL' onChange={(e) => handleInfo(e.target)} defaultValue={myInformation.webSiteURL} />
                                </div>
                            </div>
                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Wbaf.me:
                                </label>
                                <div className='col-md-9'>
                                    <a className="btn btn-sm btn-secondary" href={CreatePublicURL(auth?.data?.firstname, auth?.data?.id)} target="_blank" rel="noreferrer">
                                        {CreatePublicURL(auth?.data?.firstname, auth?.data?.id)}
                                    </a>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Profile Picture:
                                </label>
                                <div className='col-md-9'>
                                    <label htmlFor="profilePicture" className="custom-file-upload" style={{ cursor: 'pointer' }}>
                                        <i className="fa fa-cloud-upload"></i> Upload New Photo
                                    </label>
                                    <input id="profilePicture" type="file" onChange={(e) => handleInfo(e.target)} style={{ display: 'none' }} />
                                    {profilePictureBlob !== false ?
                                        <div className="profile-update-preview" style={{ position: 'relative', height: '300px', width: '100%', marginTop: '10px', backgroundColor: '#333' }}>
                                            <Cropper
                                                classes={{ containerClassName: "profile-update-preview" }}
                                                image={profilePictureBlob}
                                                crop={crop}
                                                zoom={zoom}
                                                aspect={1}
                                                onCropChange={setCrop}
                                                onCropComplete={onCropComplete}
                                                onZoomChange={setZoom}
                                            />
                                        </div> : ""}

                                    {croppedImage != null ? <img src={croppedImage} width="100%" alt="cropped preview" className="mt-2" /> : ""}
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Business Card:
                                </label>
                                <div className='col-md-9'>
                                    <label htmlFor="businessCard" className="custom-file-upload" style={{ cursor: 'pointer' }}>
                                        <i className="fa fa-cloud-upload"></i> Upload Business Card
                                    </label>
                                    <input id="businessCard" type="file" onChange={(e) => handleInfo(e.target)} style={{ display: 'none' }} />
                                    {businessCardBlob !== false ?
                                        <div className="preview mt-2">
                                            <img src={businessCardBlob} width="50%" className="img-thumbnail rounded" alt="business card preview" />
                                        </div> : ""}
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    Password:
                                </label>
                                <div className='col-md-9 mt-1'>
                                    <a href="https://id.wbaforum.org/MyProfile/ChangePassword" target="_blank" rel="noreferrer" style={{ color: "blue", fontSize: '13px' }}>Click here to change your password.</a>
                                </div>
                            </div>

                            <div className='row mb-3'>
                                <label className='col-form-label col-md-3 font-weight-bold'>
                                    E-Mail Notifications:
                                </label>
                                <div className='col-md-9 mt-1'>
                                    <label className="switch">
                                        <input type="checkbox" id="emailPermission" defaultChecked={auth?.data?.emailPermission} onChange={(e) => handleInfo(e.target)} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer bg-white border-top py-3 d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={handleCancel} className="me-2">
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSaveBiography}>
                            Save Changes
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
